<template>
    <div class="home-page">
      <HeaderNav />
      <!-- <HeroSection />
      <AboutSection /> -->
      <HeroSection class="section-spacing" />
    <AboutSection class="section-spacing" />
      <FooterInfo />
    </div>
  </template>
  
  <script>
  import HeaderNav from './HeaderNav.vue';
  import HeroSection from './HeroSection.vue';
  import AboutSection from './AboutSection.vue';
  import FooterInfo from './FooterInfo.vue';
  
  export default {
    name: 'HomePage',
    components: {
      HeaderNav,
      HeroSection,
      AboutSection,
      FooterInfo,
    },
  };
  </script>
  
  <style scoped>
  .home-page {
    display: flex;
    flex-direction: column;
    min-height: 100vh; /* 确保内容至少填满屏幕 */
  }
  .section-spacing {
  margin-top: 0.1rem; /* Top margin for all sections except the first (HeaderNav) */
  margin-bottom: 2rem; /* Bottom margin */
  /*  Optional:  Add padding for better spacing within sections */
  /* padding: 1rem;  */ 
}
    /*移动端*/
    @media (max-width: 768px) {
        .home-page{
            /*可以根据需要调整*/
        }
        .section-spacing {
     margin-top: 0.1rem; /* Smaller margins on mobile */
     margin-bottom: 1rem;
  }
    }
  </style>